import * as React from 'react';
import { Col, FormGroup, ControlLabel } from 'react-bootstrap';
import * as Features from '../../../../shared/Features';
import { Translate } from '../../../../shared/LanguageService';
import FormSelect from '../../../../components/common/FormSelect';

interface IScandphotosCreateOrderBrokerAndFirmPageProps {
    user: any;
    selectedBrokerAgentId: any;
    onAgentChanged: (e: any) => void;
    onFirmChanged: (e: any) => void;
    availableBrokerAgents: any[];
    getAvailableBrokerFirms: () => any[];
}

const ScandphotosCreateOrderBrokerAndFirmPage = (
    props: IScandphotosCreateOrderBrokerAndFirmPageProps
) => {
    return (
        <fieldset>
            <Col xs={12} md={6}>
                <h2>
                    {Translate('scandphotos/orders/create/subview/broker-and-firm/label/agent')}
                </h2>
                <FormGroup className="required">
                    <ControlLabel>
                        {Translate(
                            'scandphotos/orders/create/subview/broker-and-firm/label/agent-selection'
                        )}
                    </ControlLabel>
                    <FormSelect
                        autoFocus={true}
                        name="orderAgent"
                        value={props.selectedBrokerAgentId}
                        onChange={props.onAgentChanged}
                    >
                        {props.availableBrokerAgents.map((x: any) => (
                            <option value={x.id} key={x.id}>
                                {x.name}
                            </option>
                        ))}
                    </FormSelect>
                </FormGroup>
            </Col>
            <Col xs={12} md={6}>
                <h2>{Translate('scandphotos/orders/create/subview/broker-and-firm/label/firm')}</h2>
                <FormGroup className="required">
                    <ControlLabel>
                        {Translate(
                            'scandphotos/orders/create/subview/broker-and-firm/label/firm-selection'
                        )}
                    </ControlLabel>
                    <FormSelect
                        autoFocus={Features.hasFeature(Features.AssistCreateOrder, props.user)}
                        name="orderFirm"
                        onChange={props.onFirmChanged}
                    >
                        {props
                            .getAvailableBrokerFirms()
                            .filter((x: any) => x.isHeadQuarter)
                            .map((x: any) => (
                                <option value={x.id} key={x.id}>
                                    {x.name + '(Huvudkontor)'}{' '}
                                </option>
                            ))}
                        {props
                            .getAvailableBrokerFirms()
                            .filter((x: any) => !x.isHeadQuarter)
                            .map((x: any) => (
                                <option value={x.id} key={x.id}>
                                    {x.name}
                                </option>
                            ))}
                    </FormSelect>
                </FormGroup>
            </Col>
        </fieldset>
    );
};

export default ScandphotosCreateOrderBrokerAndFirmPage;

{
    /*<OverlayTrigger overlay={<Tooltip id={pkg.id}>{pkg.extraText}</Tooltip>} placement="top" delayShow={300} delayHide={150}></OverlayTrigger>*/
}
